import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import TemporaryError from '@/components/tax-refund/common/view/ErrorView/TemporaryError';
import { COMMON_PATHS, INDIVIDUAL_PATHS } from '@/lib/constants/paths';

const TemporaryErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleRetry = () => {
    sendClickEvent('indis-lookup_error-temp_retry');

    router.replace({
      pathname: `${INDIVIDUAL_PATHS.개인수집및조회}`,
      query: { type: 'indis' }
    });
  };
  const handleClickExit = () => {
    sendClickEvent('indis-lookup_error-temp_close');

    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'indis-lookup_error-temp'}>
        <Layout
          rightTextButton={{
            label: '나가기',
            state: 'gray',
            onClick: handleClickExit
          }}
        >
          <TemporaryError onPrimaryButtonClick={handleRetry} footerClickEvent="indis-lookup_error-temp" />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default TemporaryErrorPage;
